/** @format */

const jobsDustLogs = {
  // jobs 页曝光
  jobsPageShowLog: {
    event: 'page_show',
    params: {
      page: 'jobs',
    },
  },
};

export default jobsDustLogs;
